module.exports = "<div ng-class=\"['toggler', {opened: $ctrl.togglerOpened}]\" ng-click=\"$ctrl.toggle()\" ng-transclude=\"item\">\n  \n</div>\n<div ng-class=\"['toggle-content', 'padding-bottom-n', {opened: $ctrl.togglerOpened}]\" ng-transclude=\"content\">\n  \n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpToggler/adpToggler.html
// module id = 483
// module chunks = 0